var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 92,
    viewBox: "0 0 83 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.847 10.4531C31.5955 6.76504 36.6859 4.68775 42 4.68775C47.3141 4.68775 52.4045 6.76504 56.153 10.4531C59.9004 14.1402 62 19.1343 62 24.3352V39.6536H22V24.3352C22 19.1343 24.0996 14.1402 27.847 10.4531ZM18 39.6536V24.3352C18 18.0546 20.5361 12.0376 25.0403 7.60595C29.5434 3.17537 35.6446 0.69165 42 0.69165C48.3554 0.69165 54.4566 3.17537 58.9597 7.60595C63.4639 12.0376 66 18.0546 66 24.3352V39.6536H72.2222C78.1637 39.6536 83 44.4408 83 50.3704V80.8861C83 86.8157 78.1637 91.6029 72.2222 91.6029H10.7778C4.83627 91.6029 0 86.8157 0 80.8861V50.3704C0 44.4408 4.83627 39.6536 10.7778 39.6536H18ZM64 43.6497H20H10.7778C7.02362 43.6497 4 46.6695 4 50.3704V80.8861C4 84.587 7.02362 87.6068 10.7778 87.6068H72.2222C75.9764 87.6068 79 84.587 79 80.8861V50.3704C79 46.6695 75.9764 43.6497 72.2222 43.6497H64Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79.6146C50.732 79.6146 57 73.3527 57 65.6282C57 57.9038 50.732 51.6419 43 51.6419C35.268 51.6419 29 57.9038 29 65.6282C29 73.3527 35.268 79.6146 43 79.6146Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9258 61.4324C39.2549 60.4976 39.9046 59.7094 40.7597 59.2073C41.6148 58.7053 42.6202 58.5217 43.5978 58.6892C44.5754 58.8568 45.4621 59.3645 46.1009 60.1226C46.7397 60.8807 47.0893 61.8401 47.0878 62.831C47.0878 65.6283 42.8878 67.0269 42.8878 67.0269",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 72.6214H43.014",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.33aa7c85c5425d705ecf72b8ce061a6a.svg";
export { ForwardRef as ReactComponent };